module.exports = __webpack_public_path__ + "static/no-gluten-ab8807fb4627bbab1388b53fc46f6b4d.png";